import React from 'react';
import axios from 'axios';
import qs from 'qs';
import Moment from 'react-moment';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import { withSnackbar } from 'notistack';
import Fab from '@material-ui/core/Fab';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import ReportCardsDetailsTargets from './ReportCardsDetailsTargets';
import ReportCardsDetailsComment from './ReportCardsDetailsComment';
import ReportCardsDetailsEditCommentDialog from './ReportCardsDetailsEditCommentDialog';
import ConfirmDialog from '../ConfirmDialog';

const styles = theme => ({
  label: {
    fontSize: 12,
    color: '#616161',
  },
  group: {
    marginBottom: 20,
    marginTop: 10,
  },
  addNewCommentButton: {
    margin: '10px 0',
  },
  noComments: {
    marginBottom: 10,
  },
});

const mapStateToProps = state => {
  return {
    selectedPupil: state.selectedPupil,
  };
};


class ReportCardsDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isLoaded: false,
      data: props.reportCard,
      meta: {},
      isEditCommentDialogOpen: false,
      selectedCommentData: {},
      isDeleteDialogOpen: false,
    };

    this.axiosCancel = null;

    this.reloadData = this.reloadData.bind(this);
    this.onNewCommentClick = this.onNewCommentClick.bind(this);
    this.onCommentSave = this.onCommentSave.bind(this);
    this.onCommentEditClick = this.onCommentEditClick.bind(this);
    this.onCommentDeleteClick = this.onCommentDeleteClick.bind(this);
    this.onDeleteDialogClick = this.onDeleteDialogClick.bind(this);
  }

  componentDidMount() {
    this.reloadData();
  }

  componentWillUnmount() {
    if (this.axiosCancel) {
      this.axiosCancel();
    }
  }

  reloadData() {
    const {
      reportCard,
      selectedPupil,
    } = this.props;

    if (!selectedPupil) {
      return;
    }

    this.setState({
      isLoading: true,
    });

    axios
      .get(
        `${window.apiUrl}/getpupilreportcard/${reportCard.id}?pupil_id=${selectedPupil.id}`,
        {
          cancelToken: new axios.CancelToken((c) => { this.axiosCancel = c }),
        }
      )
      .then((response) => {
        if (response.data.success) {
          this.setState({
            data: response.data.data,
            meta: response.data.meta,
          });
        }

        this.setState({
          isLoading: false,
          isLoaded: true,
        });
      })
      .catch((thrown) => {});
  }

  onNewCommentClick() {
    this.setState({
      isEditCommentDialogOpen: true,
      selectedCommentData: {},
    });
  }

  onCommentSave() {
    this.setState({
      isEditCommentDialogOpen: false,
    }, () => {
      this.reloadData();
    });
  }

  onCommentEditClick(comment) {
    this.setState({
      isEditCommentDialogOpen: true,
      selectedCommentData: comment,
    });
  }

  onCommentDeleteClick(comment) {
    this.setState({
      isDeleteDialogOpen: true,
      selectedCommentData: comment,
    });
  }

  onDeleteDialogClick() {
    const {
      selectedCommentData,
    } = this.state

    axios
      .post(
        `${window.apiUrl}/deletepupilreportcardcomment`,
        qs.stringify({
          pupil_report_card_comment_id: selectedCommentData.id,
        }),
        {
          cancelToken: new axios.CancelToken((c) => { this.axiosCancel = c }),
        }
      )
      .then(() => {
        this.setState({
          isDeleteDialogOpen: false,
        }, () => {
          this.reloadData();
        })
      })
      .catch((thrown) => {});
  }

  render() {
    const {
      t,
      classes,
    } = this.props;
    const {
      isLoading,
      isLoaded,
      data,
      meta,
      isEditCommentDialogOpen,
      selectedCommentData,
      isDeleteDialogOpen,
    } = this.state;

    return (
      <div className="report-card-details">
        {isLoading && (
          <CircularProgress />
        )}
        {isLoaded && (
          <>
            <Grid container>
              <Grid item md={4} sm={6} xs={12}>
                <div className={classes.group}>
                  <div className={classes.label}>{t('Date range')}</div>
                  <div className={classes.value}>
                    <Moment format={'ddd ' + dateFormat}>{data.start_date}</Moment>
                    <span> - </span>
                    <Moment format={'ddd ' + dateFormat}>{data.end_date}</Moment>
                  </div>
                </div>
              </Grid>
              <Grid item md={3} sm={6} xs={6}>
                <div className={classes.group}>
                  <div className={classes.label}>{t('Report type')}</div>
                  <div className={classes.value}>{data.reason}</div>
                </div>
              </Grid>
              {data.level && (
                <Grid item md={2} sm={6} xs={2}>
                  <div className={classes.group}>
                    <div className={classes.label}>{t('Level')}</div>
                    <div className={classes.value}>{data.level}</div>
                  </div>
                </Grid>
              )}
              {data.teacher && (<Grid item md={3} sm={6} xs={4}><div className={classes.group}>
                <div className={classes.label}>{t('Created by')}</div>
                <div className={classes.value}>{data.teacher}</div>
              </div></Grid>)}
            </Grid>
            <div className={classes.group}>
              <div className={classes.label}>{t('Description')}</div>
              <div className={classes.value}>{data.description}</div>
            </div>
            <ReportCardsDetailsTargets data={data} meta={meta} />
            <div className={classes.group}>
              <div className={classes.label}>{t('Comments')}</div>
              {appType === 'parent' && (
                <Fab
                  size="small"
                  variant="extended"
                  color="secondary"
                  onClick={this.onNewCommentClick}
                  className={classes.addNewCommentButton}
                >
                  {t('Add new comment')}
                </Fab>
              )}
              {(!data.parent_comments || (data.parent_comments && data.parent_comments.length === 0)) && (
                <div className={classes.noComments}>{t('No comments yet')}</div>
              )}
              {data.parent_comments && data.parent_comments.length > 0 && data.parent_comments.map((comment) => {
                return (
                  <div className={classes.group} key={comment.id}>
                    <ReportCardsDetailsComment
                      data={comment}
                      onEditClick={this.onCommentEditClick}
                      onDeleteClick={this.onCommentDeleteClick}
                    />
                  </div>
                );
              })}
            </div>
          </>
        )}
        <ReportCardsDetailsEditCommentDialog
          useSuspense={false}
          pupilReportCardId={data.id}
          data={selectedCommentData}
          isOpen={isEditCommentDialogOpen}
          onClose={() => this.setState({
            isEditCommentDialogOpen: false,
          })}
          onSave={this.onCommentSave}
        />
        <ConfirmDialog
          useSuspense={false}
          title={t('Delete comment')}
          isOpen={isDeleteDialogOpen}
          onClose={() => this.setState({
            isDeleteDialogOpen: false,
          })}
          onConfirm={this.onDeleteDialogClick}
        >
          {t('Are you sure you want to delete this comment?')}
        </ConfirmDialog>
      </div>
    );
  }
}

export default connect(mapStateToProps)(
  withStyles(styles)(withSnackbar(withTranslation()(ReportCardsDetails)))
);
